<script setup lang="ts">
  import RouteParam from '@/enums/RouteParam'
  import { useAppRouting } from '@/composables/useAppRouting'

  import SubjectResource from '@/components/SubjectResource.vue'

  const { getContentIdFromRouteParam } = useAppRouting()
  const contentId = getContentIdFromRouteParam(RouteParam.SubjectResource)
</script>

<template>
  <SubjectResource :content-id="contentId" />
</template>
